/* eslint-disable */
import React from 'react';
import * as Yup from 'yup';
import { Formik, FormikHelpers } from 'formik';
import { Box, Stack } from '@mui/material';
import { TextField, OtpField } from 'components/Form';
import { Button, Typography } from 'components';
import { useResetPassword } from 'api/sdk';
import { convertServerErrors } from 'utils/form';
import { useSnack } from 'plugins/snack';

interface IVerifyEmailFormValues {
  email: string;
  password: string;
  otp: string;
}

interface IVerifyEmailFormProps {
  email: string;
  onSubmit: (values: IVerifyEmailFormValues) => void;
}
const VerifyEmailForm: React.FC<IVerifyEmailFormProps> = ({
  email,
  onSubmit
}) => {
  const { mutateAsync, error, isError, isLoading } = useResetPassword();
  const snack = useSnack();
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string().required('Password is required'),
    otp: Yup.string().required('OTP is required')
  });

  const verifyEmailFormInitialValue: IVerifyEmailFormValues = {
    email,
    password: '',
    otp: ''
  };

  const handleSubmit = async (
    values: IVerifyEmailFormValues,
    formik: FormikHelpers<IVerifyEmailFormValues>
  ) => {

    const password = values.password;

    if (password.length < 8) {
      formik.setErrors({ password: 'Password must be at least 8 characters long.' });
      return
    }

    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+{}:<>?.]/.test(password);

    if (!(hasLowercase && hasUppercase && hasSpecialChar)) {
      formik.setErrors({ password: ' Password must contains uppercase, lowercase and special character.' });
      return;
    }
    mutateAsync({
      data: {
        email: values.email,
        password: values.password,
        otp: Number(values.otp)
      }
    })
      .then(() => {
        onSubmit(values);
      })
      .catch(err => {
        // if (err.response.status === 422) {
        //   formik.setErrors(convertServerErrors(err.response.data.detail));
        //   snack({
        //     message: err.response.data.detail,
        //     severity: 'error'
        //   });
        // }
        if (err.response.status === 400) {
          snack({
            message: err.response.data.detail,
            severity: 'error'
          });
        }
        if (err.response.status === 404) {
          formik.setErrors({ email: 'User not found' });
        }
      });
  };

  return (
    <Formik<IVerifyEmailFormValues>
      initialValues={verifyEmailFormInitialValue}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {formik => (
        <form onSubmit={formik.handleSubmit}>
          <Box>
            <Stack spacing={3}>
              <TextField
                name="email"
                label="Email"
                type="email"
                light
                boootstrap
              />
              <TextField
                name="password"
                label="New Password"
                type="password"
                light
                boootstrap
              />
              <div style={{ marginTop: '40px' }}>
                <OtpField name="otp" label="Code" />
              </div>


              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                Verify Email
              </Button>
            </Stack>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default VerifyEmailForm;
